// Don't Delete this since these are tests of our standard database
const ngTestNames = [
  "Total Bilirubin",
  "Direct Bilirubin",
  "Indirect Bilirubin",
  "Protein (Total)",
  "Albumin",
  "Globulin",
  "Albumin : Globulin ratio",
  "SGOT (AST)",
  "SGPT (ALT)",
  "GGT",
  "ALLERGY INDIVIDUAL MARKER PEANUT",
  "LDH",
  "SGOT (ALT)",
  "T3 (Triiodothyronine)",
  "T4 (Thyroxine)",
  "TSH",
  "Anti Thyroglobulin Abs",
  "Free T3 (Triiodothyronine)",
  "Free T4 (Thyroxine)",
  "Iron",
  "UIBC",
  "TIBC",
  "Transferrin Serum",
  "% Saturation Transferrin",
  "G6PD (Quantitative)",
  "Sickle Cell Solubility Test-Sickling phenomenon",
  "Ferritin",
  "Blood Urea",
  "Blood Urea Nitrogen (BUN)",
  "Serum Creatinine",
  "Uric Acid",
  "Urea : Creatinine ratio",
  "BUN : Creatinine ratio",
  "Albuminuria",
  "Glomerular Filtration Rate",
  "Glomerular Filtration Rate CKD",
  "Sodium",
  "Potassium",
  "Chloride",
  "Calcium",
  "Phosphorus",
  "Magnesium",
  "Zinc",
  "Blood Sugar (Fasting)",
  "Blood Sugar (Random)",
  "Blood Sugar (Postprandial)",
  "HbA1c (Glycosylated Haemoglobin)",
  "eAG (Estimated Average Glucose)",
  "Amylase",
  "Microalbumin",
  "Glucose in Urine",
  "Insulin (Random)",
  "Insulin (Fasting)",
  "Blood Group",
  "PT TEST",
  "Activated Partial Thromboplastin Time",
  "D-Dimer",
  "Vitamin D (25-Hydroxy)",
  "Vitamin B12",
  "Vitamin B9",
  "Vitamin B6",
  "Vitamin B1",
  "Vitamin B2",
  "Vitamin C",
  "Vitamin A",
  "Vitamin E Tocopherol",
  "ALP",
  "RA factor (quantitative)",
  "ASO (quantitative)",
  "Urine Colour",
  "ALLERGY, INDIVIDUAL MARKER, BUCKWHEAT",
  "Allergen-ACTH",
  "Urobilinogen",
  "Bile Salts",
  "Bile Pigment",
  "Bilirubin",
  "Ketone",
  "Blood",
  "Protein",
  "Nitrite",
  "Leukocytes",
  "Absorbic Acid",
  "Urinary Calcium",
  "Specific Gravity",
  "pH",
  "Pus Cells",
  "RBC count",
  "Casts",
  "Crystals",
  "Epithelial Cells",
  "Bacteria",
  "URINE SPOT PROTEIN",
  "URINE SPOT CREATININE",
  "SPOT PROTEIN & CREATININE RATIO",
  "DEPOSITS :",
  "Acetone",
  "Amorphous Deposit",
  "Other compounds in Urine",
  "Candida in Urine",
  "Apo A",
  "Apo B",
  "APO B : APO A Ratio",
  "Homocysteine",
  "Allergen-Gluten",
  "Total Cholesterol",
  "Triglycerides",
  "HDL Cholesterol",
  "LDL Cholesterol",
  "VLDL",
  "HsCRP",
  "Total Cholesterol : HDL ratio",
  "LDL : HDL ratio",
  "Non - HDL Cholesterol",
  "Total Leukocyte Count",
  "Neutrophils",
  "Abs. Neutrophil Count",
  "Lymphocytes",
  "Abs. Lymphocyte Count",
  "Eosinophils",
  "Abs. Eosinophil Count",
  "Monocytes",
  "Abs. Monocyte Count",
  "Basophils",
  "Abs. Basophil Count",
  "Immature Granulocytes",
  "Abs. Immature Granulocytes",
  "Platelet Count",
  "P-LCR",
  "PDW",
  "MPV",
  "PCT",
  "Nucleated red blood cells",
  "Absolute Nucleated red blood cells",
  "Large Unstained Cell",
  "Absolute Large Unstained Cell",
  "Peripheral smear",
  "Reticulocytes Count",
  "Meta-Myelocytes",
  "Pro-Myelocytes",
  "Atypical Lymphocytes (LUC)",
  "Blast Cells",
  "PT (Control)",
  "Mean Normal Prothrombic Time",
  "Partial Thromboplastin Time(Control)",
  "PT-INR",
  "PT ratio",
  "RDW",
  "Rh Factor",
  "Haemoglobin",
  "Allergy Acacia Spp (Acacia)",
  "MCV",
  "MCH",
  "MCHC",
  "Haematocrit",
  "RDW-SD",
  "RDW-CV",
  "Estradiol (E2)",
  "AMH",
  "Androstenedione",
  "Testosterone",
  "Leutinizing Harmone",
  "FSH",
  "Estrogen",
  "Progesterone",
  "DHEA-Sulphate",
  "Prolactin",
  "Urine for Beta HCG",
  "Pregnancy Test Serum",
  "Semen Type",
  "Prostate-Specific Antigen Total",
  "CA 125",
  "CA 15-3",
  "CA 19-9",
  "CEA",
  "Dengue NS1",
  "Malaria (VIVAX)",
  "Rubella Ab IgM",
  "Varicella Zoster Ab IgG",
  "Prostate-Specific Antigen Free",
  "HBsAg",
  "Anti HCV",
  "HAV AB",
  "HAV AB Total",
  "HCV AB",
  "HAV AB IgM",
  "CMV AB IgG",
  "HBsAb",
  "Allergy Acarus Siro (Flour Mite) By EIA",
  "Allergy Acetylcysteine",
  "HBcAb Total",
  "Allergy Agrostis Stolonifera (Bentgrass) By EIA",
  "Typhidot",
  "WIDAL TEST (SLIDE METHOD)",
  "Helicobacter Antigen in Stool",
  "Helicobacter Pylori Abs.(IgG)",
  "Helicobacter Pylori Abs.(IgM)",
  "Urea Breath Test",
  "Gram Stain",
  "Allergy Amaranthus Retroflexus (Common Pigweed)",
  "VDRL",
  "HIV AB",
  "HIV Combo (Ag+Ab)",
  "Herpes Semplex Virus II IgM",
  "Chlamydia IgM",
  "TPHA (TREPONEMA PALLIDUM)",
  "Allergy Ambroxol",
  "Allergy Anise",
  "Allergy Anthoxanthum Odoratum (Sweet Vernal Grass)",
  "Allergy Apricot",
  "Allergy Ascaris Lumbricoides",
  "Allergy Aspirin",
  "Toxoplasma Ab IgG",
  "Toxoplasma Ab IgM",
  "Rubella Ab IgG",
  "Allergy Azithromycin",
  "Stool Consistency",
  "Stool Odour",
  "Allergy Basil",
  "Allergy Beet",
  "Allergy Benzocaine",
  "Allergy Black",
  "Polymorphonuclear Leukocytes",
  "Allergy Books Dust",
  "Allergy Brassica Napus (Rape)",
  "Allergy Broccoli",
  "Allergy Bromhexine",
  "Allergy Budgerigar Dropping",
  "Allergy Budgerigar Feathers",
  "Allergy Budgerigar Serum Proteins",
  "Allergy Canarian Feathers",
  "Allergy Cardamon",
  "Appearance",
  "VOLUME",
  "Allergy Cherry",
  "Allergy Chicken Droppings",
  "Sperm Count / ml",
  "Sperm Count / ejaculate",
  "Allergy Chicken Feathers",
  "Allergy Chloramphenicol",
  "Allergy Clarithromycin",
  "Allergy Co-Trimoxazole",
  "Allergy Cobalamin",
  "Allergy Cranberry",
  "Allergy Curcuma",
  "Allergy Curry",
  "Allergy Dactylis Glomerata (Cocksfoot)",
  "RBC",
  "Primary Smear of Semen",
  "IgE Total",
  "IgM Level",
  "CK-MB",
  "Creatine-Kinase",
  "Troponin I",
  "Allergy Date",
  "Lupus Anticoagulant",
  "Anti Cardiolipin IgM",
  "Anti CCP",
  "Anti DNA Abs.",
  "Coombs Test (Indirect)",
  "Anti-Phospholipid (IgG)",
  "ANA-Titer",
  "Anti-TPO",
  "Anti-Tissue Transglutaminase IgA",
  "Growth Hormone",
  "Cortisol Serum (p.m)",
  "Alfa Feto Protein (AFP)",
  "Lipase",
  "HbF",
  "HbA",
  "HbS",
  "HbC",
  "HbA2",
  "IL6",
  "CRP",
  "ESR",
  "Anti Nuclear Antibodies (ANA)",
  "Anti Cardiolipin IgG",
  "Allergy Drug Insulin Human By Immuno CAP",
  "Allergy Duck Feathers",
  "Allergy Duck Meat",
  "Serum Folate",
  "HDW (Haemoglobin Distribution Width)",
  "Serum Copper",
  "Aluminium",
  "Antimony",
  "Arsenic",
  "Barium",
  "Beryllium",
  "Bismuth",
  "Cadmium",
  "Caesium",
  "Chromium",
  "Cobalt",
  "Lead",
  "Manganese",
  "Mercury",
  "Molybdenum",
  "Nickel",
  "Selenium",
  "Silver",
  "Strontium",
  "Thallium",
  "Tin",
  "Uranium",
  "Vanadium",
  "Allergy Euroglyphus Maynei (House Mite)",
  "Systolic",
  "Allergy Fennel",
  "Allergy Festuca Elatior (Meadow Fescue)",
  "Allergy Fig",
  "Allergy Flax Seed",
  "HBcAb IgM",
  "CMV AB IgM",
  "Herpes Semplex Virus I IgM",
  "Malaria (FALCIPARUM)",
  "Dengue IgM",
  "HIV",
  "Covid-19 IgG",
  "COVID 19 IgM",
  "COVID Antibody",
  "COVID RT-PCR",
  "Cycle Threshold N-gene",
  "Cycle Threshold E-gene",
  "Cycle Threshold RDRP",
  "Cycle Threshold Orf 1a-gene",
  "Allergy Flaxseed",
  "Allergy Gelatin",
  "Allergy Gentamycin",
  "Allergy Glycyphagus Domesticus (Store Mite)",
  "Allergy Goose Feathers",
  "Allergy Helminthosporium Halodes",
  "Allergy Henna",
  "Allergy Heterocera Mix (Moth)",
  "Allergy Housefly Musca Domestica",
  "Allergy Ibuprofen",
  "Allergy Jute",
  "Allergy Ketoprofen",
  "Allergy Kiwi",
  "Allergy Lentil",
  "Allergy Lentil (Dal)",
  "Allergy Lepidoglyphus Destructor (Hay Mite)",
  "Allergy Lidocaine",
  "Allergy Lobster",
  "Allergy Lychee",
  "Allergy Mackerel",
  "Allergy Metronidazole",
  "Allergy Mint",
  "Allergy Morus Alba (Red Mulberry)",
  "Allergy Mouse (Epithelium, Serum, Urine, Protein)",
  "Allergy Mucor",
  "Allergy Mucor Racemosus",
  "Allergy Naproxen",
  "Allergy Nart V1 Artemisia Vulgaris (Mugwort)",
  "Allergy Neomycin",
  "Allergy Olive",
  "Allergy Oregano",
  "Allergy Oxacillin",
  "Herpes Semplex Virus",
  "Thrombin Time",
  "Allergy P4 Anisakis",
  "Allergy Paracetamol",
  "ph in semen",
  "ph in abg",
  "Allergy Parsley",
  "Allergy Peach",
  "Allergy Pear",
  "Allergy Penicilloyl G",
  "Allergy Penicilloyl V",
  "Allergy Phleum Pratense (Timothy) By EIA",
  "Allergy Phoma Betae",
  "Allergy Phosphomycin",
  "Allergy Phragmites Communis (Common Reed) By EIA",
  "Allergy Pig Epithelium",
  "Allergy Pigeon Droppings",
  "Allergy Pigeon Feathers",
  "Allergy Plum",
  "Allergy Pomegranate",
  "Allergy Pork",
  "Allergy Prilocaine",
  "Allergy Prosopis Juliflora (Mesquite)",
  "Allergy Pumpkin",
  "Allergy Pumpkin Seed",
  "Allergy Pyridoxine",
  "Allergy Rabbit Epithelium",
  "Allergy Raisin",
  "Allergy Rhizopus Nigricans",
  "Allergy Rifampicin",
  "Allergy Rosemary",
  "Allergy Saffron",
  "Allergy Salix Caprea (Willow)",
  "Allergy Salmon",
  "Allergy Sardine",
  "Allergy Semolina",
  "Allergy Sheep Epithelium",
  "Allergy Sorghum Halepense (Johnson Grass)",
  "Allergy Tea",
  "Allergy Thiamine",
  "Allergy Thyme",
  "Allergy Toxocara Canis",
  "Allergy Trichoderma Viride",
  "Allergy Tuna",
  "Allergy Turkey",
  "Allergy Turkey Feathers",
  "Allergy Turnip",
  "Allergy Tyrophagus Putresentiae (Cheese Mite)",
  "Allergy Vanilla",
  "Allergy Vespula Germanica (Common Wasp - Yellow Jacket)",
  "Allergy Walnut",
  "Allergy White Bean",
  "Allergy Whole",
  "Allergy Xanthium Commune (Cocklebur)",
  "Allergy Yogurt",
  "Allergy: Carp FISH",
  "Allergy: Cashew (Kaju) By ImmunoCAP",
  "Allergy: Food Basil By ImmunoCAP",
  "Allergy: Mulberry (Shahtoot) By ImmunoCAP",
  "Allergy: Olive By ImmunoCAP",
  "Allergy: Phadiatop (< 5 Years)",
  "Allergy: Poppy",
  "Allergy: Ragweed",
  "Almond",
  "Alpha Feto Protein - CSF",
  "Alternaria Tenuis",
  "Amoxicillin",
  "Apple",
  "Aspergillus Niger",
  "Baker's Yeast Allergy",
  "Banana Allergy",
  "Bananas",
  "Beans",
  "Beef",
  "Bermuda Grass",
  "Black Pepper",
  "Cabbage",
  "Carrot Allergy",
  "Cashewnut",
  "Cat Dander",
  "Cauliflowers",
  "Celery",
  "Cephalosporin",
  "Cheese",
  "Chenopodium Album",
  "Chicken Allergy",
  "Chocolate Allergy",
  "Cinnamons",
  "Cladosporium hebarum",
  "Cloves",
  "Cloxacillin",
  "Coconut",
  "Codfish Allergy",
  "Coffees",
  "Corianders",
  "Cotton Fibre",
  "Cow Dander",
  "Cow Milk Allergy",
  "Crab",
  "Cucumbers",
  "Curd",
  "Cynodon Dactylon",
  "Derm Farinae",
  "Diclofenac",
  "Dog Dander",
  "Doxycycline",
  "Egg White Allergy",
  "Egg Yolk Allergy",
  "Eggplant",
  "Erythromycin",
  "Eucalyptus",
  "Fish (cod)",
  "Garlic",
  "Ginger",
  "Goat Dander",
  "Grapes",
  "Guavas",
  "HLA – ABACAVIR HYPERSENSTIVITY",
  "Hay Dust",
  "Honey Bee",
  "House Dust",
  "Lamb Allergy",
  "Latex",
  "Lemons",
  "Lettuce",
  "Maize",
  "Mango Allergy",
  "Melons",
  "Mosquito",
  "Mugwort Sagebrush",
  "Mushroom",
  "Mustard",
  "Mutton",
  "Nut Mix Allergy",
  "Nutmeg",
  "Oat",
  "Ofloxacin",
  "Onion Allergy",
  "Orange Allergy",
  "Papaya",
  "Pea",
  "Peanut Allergy",
  "Pearl Millet",
  "Penicillin",
  "Phadiatop",
  "Phadiatop Allergen screening -Adult",
  "Phinf  Top",
  "Pineapple",
  "Piroxicam",
  "Pistachio",
  "Potato",
  "Radishes",
  "Rice",
  "Rye Grass",
  "Sesame",
  "Sheep Wool",
  "Shrimp",
  "Shrimp/Prawn Allergy",
  "Silk",
  "Soy Bean Allergy",
  "Spinach",
  "Straw Berry",
  "Strawberry Allergy",
  "Streptomycin",
  "Sunflower",
  "Tobacco",
  "Tomato Allergy",
  "Walnut (Hazel)",
  "Wheat Flour Allergy",
  "Wood Mix",
  "Yeast",
  "Allergy: Pear (Nashpati) By ImmunoCAP",
  "Content Haemoglobin (CH)",
  "Erythropoietin",
  "G6PD (Qualitative)",
  "Glucose-6-Phosphate Dehydrogenase Enzyme Activity~G6PD Deficiency",
  "Methaemoglobin Estimation",
  "Porphobilinogen (PBG) Quantitative, 24 Hrs Urine",
  "Porphobilinogen (PBG) Quantitative, Spot Urine",
  "Porphyrins Qualitative, Spot Urine",
  "RBC (Synovial Fluid)",
  "SICKLING, SCREENING TEST",
  "Soluble Transferrin Receptor( STFR)",
  "Ionized Calcium",
  "Non Ionized Calcium",
  "RA factor (descriptive)",
  "ANA (Antinuclear Antibody)-Screen",
  "ANTI CCP (CYCLIC CITRULLINATED PEPTIDE)",
  "ANTI SOLUBLE LIVER ANTIGEN (SLA)",
  "Anti Cardiolipin IgA",
  "Anti Double Stranded DNA ( dsDNA-IgG)",
  "Anti Double Stranded DNA (DsDNA) BY IFA",
  "Anti Epidermal (Pemphigus) Antibody By IF",
  "Anti Nuclear Antibody by IFA",
  "Anti-Phospholipid (IgM)",
  "Antimitochondrial M2 Antibody.",
  "Bullous Pemphigoid 180",
  "Bullous Pemphigoid 230",
  "C3 COMPLEMENT, SERUM",
  "C4 COMPLEMENT, SERUM",
  "CENP-B",
  "CH-50Complement, total",
  "Centromere Antibody IgG",
  "Degeneration (Synovial Fluid)",
  "Desmoglein I Antibody",
  "Desmoglein III Antibody",
  "GAD-65 (GLUTAMIC ACID DECARBOXYLASE- 65) ,SERUM",
  "Glucose (Synovial Fluid)",
  "HLA B27 Detection",
  "Histone Antibody",
  "Histones",
  "Jo - 1",
  "Jo-1 Antibody IgG",
  "Ku",
  "LC-1 Antibody",
  "M2-3E (BPO) Antibody.",
  "MPO p-ANCA",
  "Mi-2",
  "Monocytes (Synovial Fluid)",
  "Nucleosomes",
  "Ovarian Antibody",
  "PCNA",
  "PM-Scl",
  "PML Antibody",
  "PR3 by EIAc-ANCA",
  "Rh Antibody Titre",
  "Rheumatoid Factors ,Qualitative",
  "Rib- P Protein",
  "Ro- 52",
  "Ro-52 Antibody",
  "SLA/LP Antibody",
  "SS-A(RO)",
  "SS-B/La",
  "SSA - A (Soluble Substance A) IgG",
  "SSB - B Antibody",
  "SSB - La (Soluble Substance B) IgG",
  "Scl - 70",
  "Scl - 70 Antibody IgG",
  "Sm",
  "Sm Antibody IgG",
  "SnRNP  ANTIBODIES",
  "Sp100 Antibody",
  "Total Proteins (Synovial Fluid)",
  "U1-nRNP/Sm",
  "Volume (Synovial Fluid)",
  "anti- liver-kidney microsomal IgG antibodies",
  "anti- liver-kidney microsomal IgG antibodies.",
  "anti-Glomerular Basement Membrane protein (GBM)",
  "c-ANCA",
  "ds-DNA",
  "gp210 Antibody",
  "p-ANCA",
  "APTT",
  "Anti Phospholipid IgA",
  "Anti Thrombin III Activity",
  "Beta-2-Glycoprotein 1 -IgG",
  "Beta-2-Glycoprotein 1 -IgM",
  "Beta-2-Glycoprotein IgM Antibody",
  "Cardiolipin Antibody ACL-IgA",
  "Control (MNAPTT)",
  "DRVVT Screening",
  "FACTOR VII FUNCTIONAL",
  "FACTOR VIII FUNCTIONAL",
  "FACTOR X FUNCTIONAL",
  "FIBRINOGEN DEGRADATION PRODUCTS (FDP), BLOOD",
  "Factor IX Functional",
  "Factor XI Activity",
  "Lupus DRVV Screen (Control)",
  "Lupus DRVV Screen (Ratio)",
  "Lupus DRVV Screen (Test)",
  "Mixing Studies Inhibitors",
  "Phosphatidylserine IgM Antibody",
  "Protein C Activity",
  "Prothrombin Gene Mutation Analysis (Factor II)",
  "Screen Ratio",
  "ABNORMAL CELLS",
  "ABSOLUTE RETICULOCYTE COUNT",
  "AMH2",
  "Absolute Granulocytes count",
  "Atypical Cell",
  "Atypical Lymphoid Cell",
  "Atypical Monocytoid cell",
  "Atypical Plasma Cell",
  "Band Cells",
  "C-Peptide (Fasting)",
  "C-Peptide (Post prandial)",
  "CORRECTED RETICULOCYTE COUNT",
  "Corrected TLC",
  "Granulocytes",
  "HEMOPARASITES",
  "IMMATURE PLATELET FRACTION",
  "IgA",
  "IgG",
  "LIC#",
  "LIC%",
  "Lymphoblasts",
  "Lymphocyte-Monocyte Ratio",
  "MENTZER INDEX",
  "MYELOBLAST",
  "Mean Platelet Component (MPC)",
  "Mean Platelet Mass (MPM)",
  "Mixed Cells",
  "Myelocytes",
  "Neutrophil Lymphocyte Ratio",
  "Neutrophil lymhocyte ratio",
  "Other Leukocyte",
  "P-LCC",
  "PDW - SD",
  "PERIPHERAL SMEAR",
  "Plasma Cell",
  "Platelate Morphology",
  "Platelet Crit",
  "Platelet(PBS)",
  "Platelet-Lymphocyte Ratio",
  "Platelets Morphology",
  "Polymorphs",
  "Promonocytes",
  "RBC Morphology",
  "RBC(PBS)",
  "RBCs",
  "RETICULOCYTE HEAMOGLOBIN EQUIVELENT",
  "Reticulocyte Index",
  "Segmented Neutrophils",
  "Total Diff %",
  "WBC Morphology",
  "WBC(PBS)",
  "Activated Protein C Resistance (APCR)",
  "Band forms",
  "Clotting Time",
  "Coagulum",
  "Haemoglobin C (HbC)",
  "Haemoglobin D (HbD)",
  "Haemoglobin E (HbE)",
  "Haemoglobin S (HbS)",
  "Heparin Induced Thrombocytopenia (HIT)",
  "LUC - (Atypical cells)",
  "Parietal Cell Antibody",
  "Prolymphocytes",
  "VANCOMYCIN",
  "Rh Factor Quantitative",
  "Blood Pressure",
  "Blood pressure",
  "Body Mass Index(BMI)",
  "Body Temperature",
  "Diastolic",
  "Height",
  "Pulse",
  "Weight",
  "Alkaline Phosphatase with Bone Fraction Ostase",
  "Beta-2-Crosslaps C-Telopeptides (BCTX)",
  "Fibroblast Growth Factor 23 (FGF 23)",
  "NTx N-Tellopeptide, 24 Hrs Urine",
  "Osteocalcin",
  "Total P1NP",
  "% fPSA",
  "Adrenaline (Epinephrine) level Urine",
  "Adrenaline (Epinephrine) level Urine 24 hrs",
  "BETA 2 MICROGLOBULIN",
  "CA 72.4 (TAG-72) GASTRIC CANCER MARKER,SERUM",
  "CYFRA 21-1 (Lung Cancer Marker)",
  "Calcitonin",
  "Carcinoembryonic Antigen (CEA) Fluid",
  "Chromogranin A",
  "DES-GAMMA CARBOXY PROTHROMBIN (DCP)/PIVKA II",
  "HCG BETA, TOTAL, TUMOR MARKER",
  "HE4 (HUMAN EPIDIDYMIS PROTEIN 4) , SERUM",
  "HOMOVANILLIC ACID (HVA)",
  "Nor Metanephrine Free, Plasma",
  "Nor-Adrenaline (Nor-epinephrine) Plasma",
  "ROMA (Post-menopausal)",
  "ROMA (Pre-menopausal)",
  "Serotonin-(5-Hydroxy Tryptamine)",
  "TNF Alpha (Tumour Necrosis Factor)",
  "Tumor marker test",
  "p2PSA",
  "phi (Prostate Health Index)",
  "BNP; B-TYPE NATRIURETIC PEPTIDE, PLASMA",
  "CK-Total",
  "Chylomicron Qualitative",
  "Chylomicron Qualitative Urine",
  "Homocysteine Qualitative",
  "LDH:Lactate Dehydrogenase",
  "Lipoprotein Associated Phospholipase A2 (Lp-PLA2)",
  "Myoglobin",
  "Myoglobin, Serum",
  "NT-Pro-BNP",
  "TROPONI - I",
  "TROPONIN-I,HIGH SENSITIVE",
  "Troponin - T",
  "Troponin-T High Sensitive",
  "Covid-19 IgG Antibody (Qualitative)",
  "N Gene CT Value",
  "Anti GAD-65 Antibody (Paraneoplastic Syndrome)",
  "Anti IA-2 (Insulinoma Associated Antigen)",
  "Average Glucose Value(Past 3 Months IFCC)",
  "Blood Glucose (1 Hour 30 Mins).",
  "Blood Glucose (2 Hour 30 Mins)",
  "Blood Glucose (30 MIns)",
  "C - PEPTIDE (Fasting)",
  "C - PEPTIDE (PP)",
  "C Peptide Random",
  "Diabetes Monitoring",
  "Fructosamine",
  "Glucose (Fluid)",
  "Glucose 2 Hour Post Load",
  "Glucose Challenge Test (GCT)",
  "Glycosylated Haemoglobin(Hb A1c) IFCC",
  "HOMA IR Index",
  "HbA1c (mmol/mol)",
  "Insulin (Postprandial)",
  "KETONE BODY (BETA HYDROXYBUTYRATE)",
  "POST GLUCOSE (BLOOD SUGAR LEVELS)",
  "Total Galactose (TGAL)~Galactosemia (GAL)",
  "Urine Glucose (30 Mins)",
  "Urine sugar(2hr)",
  "Urine sugar(3hr)",
  "ZnT8 (ZINC TRANSPORTER 8) ANTIBODY",
  "Bicarbonate",
  "Calcium Ionised",
  "Calcium, Urine by Arsenazo III dye Method",
  "Chloride, Urine",
  "Corrected Calcium",
  "Lactate",
  "MANGANESE URINE",
  "Magnesium,Serum",
  "Osmolality serum",
  "Phosphate",
  "Phosphates/Urates",
  "Phosphorus, Urine by Phosphomolybdate Method",
  "Potassium, Urine",
  "Potassium,Urine",
  "Selenium, Serum by ICPMS",
  "Sodium 24 Hours Total Volume",
  "Sodium : Potassium ratio",
  "Sodium urine by ISE Method",
  "Sodium,Urine",
  "Urinary Calcium level per day (Calculated)",
  "Urine Potassium per Day(Calculation)",
  "Urine Sodium Random",
  "Leutinizing Hormone",
  "Oestradiol",
  "SHBG",
  "Testosterone(Free)",
  "Heart Assure (High Sensitive Troponin I)",
  "HbD",
  "Unidentified",
  "Anti Hbs Titre",
  "HBeAg",
  "HBsAg Test Value",
  "HCV, IgG",
  "17-Hydroxy Progesterone",
  "17-Hydroxy Progesterone (17-OHP)~Congenital Adrenal Hyperplasia (CAH)",
  "17-HydroxyProgesterone",
  "ADH (Anti Diuretic Hormone)",
  "ANTI MULLERIAN HORMONE; AMH,SERUM",
  "Aldosterone, Serum",
  "Aldosterone, Urine",
  "Beta HCG",
  "Cortisol (Random)",
  "Cortosol Random",
  "DHEAS",
  "DHT",
  "Follicle Stimulating Hormone (FSH)",
  "Free Androgen Index",
  "IGF BP3",
  "IGF-1 (Somatomedin C)",
  "LH / FSH Ratio",
  "SEX HORMONE BINDING GLOBULIN (SHBG),SERUM",
  "Serum for Beta HCG",
  "TSH (Thyroid Stimulating Hormone)~Congenital Hypothyroidism (CH)",
  "Plasma Renin Direct",
  "CD3",
  "CD3-/CD(16+56)++",
  "CD4",
  "CD4/CD8 ratio",
  "CD8",
  "IMMUNOGLOBULIN IgA,Serum",
  "IMMUNOGLOBULIN IgG,Serum",
  "IMMUNOGLOBULIN IgM, SERUM",
  "Natural Killer Cells",
  "ANTI HEV IgG",
  "ASCA IgA",
  "ASCA IgG",
  "ASO Qualitative",
  "Adenosine Deaminase; ADA",
  "Adenovirus IgG",
  "Adenovirus IgM Antibody",
  "Agglutination",
  "Anti-HBc IgM",
  "Anti-HBe",
  "Anti-HBs",
  "Anti-HCV",
  "Anti-HDV",
  "Antistreptolysin-O ( ASO) Titre, Serum",
  "Aspergillus Antigen",
  "Beta-D-Glucan",
  "CMV IgG",
  "CMV IgM",
  "Chikungunya IgG",
  "Chikungunya IgM",
  "Chlamydia IgA",
  "Chlamydia IgG",
  "Chlamydia Trachomatis IgG",
  "Coxiella IgG",
  "Coxiella IgM",
  "Coxsackie IgG Antibody",
  "Coxsackie IgM Antibody",
  "Cryptococcus Antigen",
  "Cryptosporidium Antigen",
  "Cyst (Stool routine)",
  "Cytomegalovirus Antibody-IgM",
  "Diphtheria Antibogy IgG",
  "Direct Microscopy (Saline and Iodine mount)",
  "E Gene CT Value",
  "E. Coli Antigen",
  "EBV EA IgG",
  "EBV IgM",
  "Echinococcus IgG",
  "Entamoeba Antigen",
  "Epstein-Barr VCA IgG",
  "Estimated Titre",
  "Factor V Functional / Activity",
  "Filaria Antigen",
  "Filaria IgG",
  "Filaria IgM",
  "Form & Consistency  (Stool routine)",
  "Giardia Antigen",
  "Group B Strep",
  "H. Influenzae B",
  "HAV IgM",
  "HCV Total",
  "HDV IgM",
  "HEPATITIS B CORE ANTIBODY (Anti- HBc), TOTAL",
  "HEV IgM",
  "HIV 1&2",
  "HMPV RNA Qualitative",
  "HSV 1&2 IgM",
  "HSV-1 IgG",
  "HSV-2 IgG",
  "HTLV I & II Total Antibody",
  "Hepatitis A  Antibody (Anti-HAV)- IgG",
  "Hepatitis B Envelope Antigen (HBeAg )",
  "Hepatitis B surface antigen (HBs Ag)",
  "Herpes simplex virus 1+2, IgG",
  "Herpes simplex virus 1+2, IgM",
  "Induration in mm",
  "Influenza A IgG",
  "Influenza B IgM",
  "Influenza IgG",
  "LEPTOSPIRA ANTIBODY, IgM,SERUM",
  "LEPTOSPIRA ANTIBODY,IgG,RAPID CARD",
  "LEPTOSPIRA ANTIBODY,IgM,RAPID CARD",
  "Legionella Antigen",
  "Legionella IgG",
  "Legionella IgM",
  "Leishmania IgG",
  "Leptospira IgG",
  "Lyme IgG",
  "LymeBorrelia Burgdorferi IgM antibodies",
  "Measles IgG",
  "Measles IgM",
  "Monospot",
  "Mumps IgG",
  "Mumps IgM",
  "Mycobacterium tuberculosis complex (MTBC)",
  "Mycoplasma Pneumoniae IgG",
  "Ova (Stool routine)",
  "Parvovirus (B19) IgM*",
  "Pertussis IgG",
  "Pneumococcal Antigen",
  "Post Stool Concentration Microscopy (Saline and Iodine mount)",
  "ROTAVIRUS ANTIGEN, STOOL",
  "RPR, Serum",
  "RSV IgG",
  "RSV IgM",
  "Rabies antibody IgG",
  "RdRp Gene CT Value",
  "SARS CoV-2 RNA Qualitative",
  "SARS-CoV-2 IgG",
  "SCRUB TYPHUS (TSUTSUGAMUSHI) ANTIBODY IgM, RAPID ASSAY",
  "Salmonella Antigen",
  "Salmonella H",
  "Salmonella IgG",
  "Salmonella IgM",
  "Salmonella O",
  "Salmonella Paratyphi B(H)",
  "Salmonella paratyphi A(H)",
  "Scrub Typhus IgG",
  "Scrub Typhus IgM",
  "Syphilis Antibodies",
  "TB Antigen",
  "TB Antigen-Nil",
  "TB Nil",
  "TB Resistance",
  "TPHA",
  "Tetanus IgG",
  "Titre",
  "Treponema Pallidium Haemagglutination (TPHA) TITRE",
  "Trophozoites (Stool routine)",
  "Tuberculin Test",
  "West Nile IgG",
  "West Nile IgM",
  "Worms (Adult/Segment) (Stool routine)",
  "ZN Stain",
  "p24 antigen with HIV 1 & 2 Antibody",
  "Amyloid A",
  "C-reactive protein (CRP),Qualitative",
  "Fibrinogen level",
  "Mucus  (Stool routine)",
  "WBC count (Synovial Fluid)",
  "17 Ketosteroids,urine",
  "24 Hours Total Volume(Urine)",
  "24 Hrs total volume",
  "ALBUMIN, FLUID",
  "Albumin Qualitative, Urine",
  "Aminolevulinic acid 24Hrs Urine",
  "Calcium, Urine,",
  "Creatinine Clearence (Calculated)",
  "Creatinine Urine per day(Calculated)",
  "Creatinine, 24 hours urine (Calculated)",
  "Creatinine, Fluid",
  "Creatinine, Urine by Jaffe Method",
  "Cystatin C",
  "Cystine Quantitative, Spot Urine",
  "Microalb / Creatinine Ratio",
  "Microalbumin : Creatinine ratio",
  "Microalbumin, Urine per day",
  "Nor-Epinephrine, 24 Hrs Urine",
  "Osmolality urine",
  "Oxalate, Urine",
  "Protein,urine 24 hours",
  "SERUM BICARBONATE(D)",
  "Sodium urine per day (Calculated)",
  "Total Proteins (Fluid, Biochemical)",
  "Total urine volume in 24 hrs",
  "Urinary Phosphorus level per day (Calculated)",
  "Urine volume in 24 hours",
  "Urine volume in 24 hours.",
  "APO A : APO B Ratio",
  "Bile Acid (Fasting)",
  "Bile Acid (Postprandial)",
  "Direct LDL Cholestrol",
  "HDL % of total",
  "HDL : LDL ratio",
  "HDL :Total Cholesterol ratio",
  "Lipoprotein (a) [Lp(a)]",
  "TG : HDL Ratio",
  "TOTAL LIPID",
  "ALP - GGT RATIO",
  "AST / ALT Ratio",
  "Albumin / Creatinine ratio",
  "Alpha 2 Macroglobulin",
  "Alpha Feto Protein (AFP),Serum",
  "Bile Acids-Total",
  "Bilirubin Total (Fluid)",
  "FIB-4 Score",
  "Fatty liver Index(FLI)",
  "NAFLD Fibrosis score",
  "Pre Albumin",
  "Pseudocholinesterase,Serum",
  "SGPT (AST)",
  "Malaria Parasite",
  "ALUMINUM, SERUM",
  "Aluminum spot urine",
  "CADMIUM",
  "Cobalt Blood",
  "Copper",
  "Manganese ICPMS",
  "Phosphorus, Spot Urine",
  "Thallium - Blood",
  "Thallium ICPMS Urine Spot",
  "Zinc Urine by ICPMS",
  "ACTH, EDTA PLASMA",
  "AChR- Acetyl Choline Receptor Antibodies",
  "AMPA (Anti-glutamate receptor)-GluR1",
  "AMPA (Anti-glutamate receptor)-GluR2",
  "ANNA-1/Hu",
  "ANNA-2/Ri",
  "ASKA (Striated) Muscle Antibody",
  "Albumin CSF",
  "Amphiphysin",
  "Amphiphysin Antibody",
  "Angiotensin Converting Enzyme (ACE) CSF",
  "Anti Hu Antibody",
  "Anti Myelin Oligodendrocyte Glycoprotein (MOG)",
  "Anti Neuromyelitis Optica / Aquaporin 4 (NMO)",
  "Anti Phospholipase A2 Recepto",
  "CASPR2 antibody (VGKC type)",
  "CSF Glucose",
  "CSF Proteins",
  "CV2.1",
  "Carbamazepine (Tegretol)",
  "Cryptococcus Antigen, CSF",
  "GABA-B receptor antibody",
  "GD1a",
  "GD1b",
  "GM1",
  "GM2",
  "GM3",
  "GQ1b",
  "GT1b",
  "Immunoglobulin G (IgG), CSF",
  "Japanese Encephalitis Virus By PCR",
  "Japanese Encephalitis Virus IgM Antibody",
  "LGI-1 antibody (VGKC type)",
  "Lactate CSF",
  "Levetiracetam",
  "M2-3E (BPO) Antibody",
  "MuSK ANTIBODY",
  "Myelin Associated Glycoprotein (MAG)",
  "NMDA (Anti-glutamate receptor against NR1 subunit)",
  "Neuron Specific Enolase (NSE)",
  "PCA-1/Yo",
  "PHENYTOIN, SERUM",
  "PNMA2 (Ma2/Ta)",
  "Phenobarbitone (Gardinal)",
  "Protein Total CSF",
  "VALPROIC ACID, SERUM",
  "VDRL CSF",
  "Yo Antibody",
  "Amylase, Fluid",
  "Canine Pancreatic Lipase Immunoreactivity",
  "Feline Pancreatic Lipase Immunoreactivity",
  "Lipase Fluid",
  "Trypsin-Like Immunoractivity",
  "Alpha-fetoprotein (AFP)",
  "ESTRIOL, UNCONJUGATED / FREE (uE3), SERUM",
  "HCG Beta Subunit, Urine Spot",
  "INHIBIN A, REPRODUCTIVE MARKER , SERUM",
  "Inhibin",
  "Inhibin A",
  "PAPP-A (Pregnancy Associated Plasma Protein)",
  "PAPPa (Pregnancy Associated Plasma Protein)",
  "PlGF (Placental Growth Factor)",
  "Placental growth factor (PlGF)",
  "Pregnancy Associated Plasma Protein(PAPP-A)",
  "uE3, unconjugated Estriol",
  "Abnormal Form",
  "Abnormal Forms",
  "Abnormal Head",
  "Abnormal Neck 8 midpiece",
  "Abnormal Tail",
  "Abstinence Period",
  "Alive Spermatozoa %",
  "Analysis Time",
  "Appearance (Semen)",
  "Appearance of Semen",
  "Collection Time",
  "Days Of Abstinence",
  "Dead Spermatozoa %",
  "Immotile",
  "Immotile (IM %)",
  "Leukocyte (Semen)",
  "Liquefaction",
  "Liquefaction Time (Semen)",
  "Microscopic Examination (Microscopy) Vitality",
  "Morphology Abnormal",
  "Morphology Head Defects",
  "Morphology Mid Picce Defects",
  "Morphology Normal",
  "Morphology Tail Defects",
  "Motile",
  "Motility Assessment(After Liquefaction)",
  "Non Progressive",
  "Non Progressive (NP, %)",
  "Normal Form",
  "Progressive",
  "Progressive (PR, %)",
  "Semen Fructose",
  "Sperm Antibody (ASAB) -Total",
  "Total Motility (PR+NP, %)",
  "Volume of Semen",
  "WBCs",
  "pH of Semen",
  "Amikacin",
  "Amoxycillin",
  "Amoxycillin + Clavulanic Acid",
  "Ampicillin",
  "Ampicillin + Salbactum",
  "Aztreonam",
  "Cefazolin",
  "Cefepime",
  "Cefitriaxone",
  "Cefoperazone + Sulbactum",
  "Cefotaxime",
  "Cefoxitin",
  "Ceftazidime",
  "Cefuroxime",
  "Ciprofloxacin",
  "Cotrimoxazole",
  "Gentamicin",
  "Imipenem",
  "Levofloxacine",
  "Meropenem",
  "Norfloxacin",
  "Oflaxacine",
  "Piperacillin",
  "Piperacillin + Tazobactum",
  "Tetracycline",
  "Ticarcillin",
  "Ticarcillin + Clavulanic Acid",
  "Gonorrhoea Ag",
  "HCV",
  "HPV",
  "Hepatitis B",
  "High Vaginal Swab",
  "RAPID TP(SYPHILIS), VDRL",
  "Rapid Plasma Reagin",
  "Adult Parasite",
  "Blood (Stool routine)",
  "Cysts",
  "Epithelial Cells (Stool routine)",
  "Fat (Stool routine)",
  "OVA",
  "Occult Blood in Stool",
  "Organism Isolated",
  "Pus Cells (WBCs) (Stool routine)",
  "Pus Cells in Stool",
  "Reaction (Stool routine)",
  "Red Blood Cell",
  "Red blood Cells (Stool routine)",
  "Stool Color",
  "Stool Mucus",
  "Stool Specimen Type",
  "Trophozoites",
  "Undigested Food",
  "Undigestive Material (Stool routine)",
  "Visible Blood",
  "AMA- M2",
  "ANTI THYROID PEROXIDASE ANTIBODY;(ANTI TPO), SERUM",
  "Antimitochondrial M2 Antibody",
  "Microsomal (TPO) Antibody",
  "Mitochondrial (M2) Antibody",
  "Parathyroid Hormone (PTH)",
  "THYROGLOBULIN",
  "TSH 3RD GENERATION",
  "TSH RECEPTOR ANTIBODY, SERUM",
  "Thyroxine Binding Globulin (TBG)",
  "Ultra TSH",
  "Arsenic in 24 hrs Urine",
  "Arsenic, Urine",
  "Copper, Urine Spot",
  "Lead Urine Spot by ICPMS",
  "Lead, Blood",
  "METHADONE SCREEN, URINE",
  "METHAMPHETAMINE SCREEN, URINE",
  "Mercury Serum by ICPMS",
  "Nickel Serum",
  "Nicotine - Cotinine Urine",
  "Nicotine Metabolite, Urine",
  "Phenol Urine",
  "Albumin, Urine",
  "Chemical Examination",
  "Frank blood",
  "Ketones in Urine",
  "Leukocyte Esterase",
  "Leukocyte esterase",
  "Microorganism",
  "Protein urine",
  "Protozoa",
  "Reducing Substances",
  "Sediment",
  "Sugar in Urine",
  "Trichomonas Vaginalis",
  "Urinary Albumin",
  "Urinary Creatinine",
  "Urinary Sodium",
  "Urine Clarity",
  "Urine Ketones (1 Hour 30 Mins)",
  "Urine Ketones (2 Hour)",
  "Urine Ketones (30 Mins)",
  "Urine Odour",
  "Urine Spot Microalbumin",
  "Yeast cells",
  "Dengue IgG",
  "S.Typhi AH",
  "S.Typhi BH",
  "S.Typhi H Antibody",
  "S.Typhi O Antibody",
  "Typhoid (Widal Test)",
  "1,25-Dihydroxy vitamin D",
  "Biotin",
  "Ceruloplasmin",
  "Fat Burner",
  "Folate (Folic Acid) *",
  "Glutathione",
  "Holotranscobalamin (Active Vitamin B12)",
  "Vitamin B-Complex",
  "Vitamin B3",
  "Vitamin B3 (Niacin)",
  "Vitamin B7 (BIOTIN)",
  "Vitamin E",
  "Vitamin K1 (Phylloquinone)",
  "Partial Thromboplastin Time",
  "ISI",
  "Index",
  "Timothy Grass",
  "Cultivated Rye",
  "Alder",
  "Birch",
  "Oak",
  "Olive Tree",
  "Commn Ragweed",
  "Mugwort",
  "Dermatophagoides Pter",
  "Dermatophagoides Farinae",
  "Cockroach, German",
  "Cat",
  "Dog",
  "Horse",
  "Camel",
  "Penicillium Notatum",
  "Caldosporium Herbarium",
  "Aspergillus Fumigatus",
  "Candida Albicans",
  "Alternaria Alternata",
  "Examination of Stool",
  "Macroscopic Examination",
  "Concentration Method",
  "E. COLI",
  "E. Histolytica Cyst",
  "E.HISTOLYTICA CYST",
  "E. Histolytica Trophozoite",
  "E.HISTOLYTICA TROPHOZOITE",
  "Fat",
  "Fibres",
  "Giardia Lamblia",
  "Macrophages",
  "Parasites",
  "Reaction",
  "Starch",
  "Vegetable Cells",
  "Physical Examination",
  "Spermatozoa",
  "Examination of Urine",
  "Bandforms",
  "Differential Leucocyte Count by Flow Cytometry (Absolute Differential count by Automated)",
  "Prothrombin Index",
  "Corrected P.I.T.(1:1)",
  "HBsAg(CMIA)",
  "HBsAg(ELFA)",
  "Antigen",
  "Test For Antibodies to Human Immunodeficiency Virus (HIV) Type1/Type2",
  "Du Factor",
  "Absolute Counts",
  "Specimen",
];

export default ngTestNames;
